import { Button } from '@mui/material';
import React from 'react'

const ContainedButton = ({ onClick, btnName }) => {
    return (
        <Button
            onClick={onClick}
            sx={{
                backgroundColor: '#142C5C',
                color: '#fff',
                borderColor: '#0f2247',
                '&:hover': {
                    backgroundColor: '#0f2247',
                },
                borderRadius: '6px',
                fontSize: {
                    xs: '12px',
                    sm: '13px',
                    md: '13px',
                    lg: '14px',
                    xl: '14px'
                },
                height: '40px'
            }}
        >
            {btnName}
        </Button>
    )
}

export default ContainedButton
